var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCardClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49377 9.62598C2.0083 9.62598 0 7.61768 0 5.1322C0 2.64673 2.0083 0.625977 4.49377 0.625977C6.97925 0.625977 9 2.64673 9 5.1322C9 7.61768 6.97925 9.62598 4.49377 9.62598ZM4.49377 1.7434C2.6361 1.7434 1.12987 3.27493 1.12987 5.1326C1.12987 6.99028 2.6361 8.49651 4.49377 8.49651C6.35145 8.49651 7.88298 6.99028 7.88298 5.1326C7.88298 3.27493 6.35145 1.7434 4.49377 1.7434ZM5.71121 6.85171L4.11702 5.68448C4.00415 5.59652 3.89088 5.40814 3.89088 5.25752V2.70939C3.89088 2.57122 4.0166 2.45835 4.16722 2.45835H4.6946C4.83278 2.45835 4.94564 2.57122 4.94564 2.70939V4.71769C4.94564 4.86831 5.05851 5.05669 5.17178 5.14465L6.339 5.98573C6.45187 6.07369 6.47717 6.24922 6.38921 6.36249L6.07551 6.78945C5.98755 6.90232 5.82447 6.92762 5.71161 6.85211L5.71121 6.85171Z",
    fill: "#C2B58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardClockIcon);
export default __webpack_public_path__ + "static/media/dashboard-card-clock-icon.c6d3ec2f9cc60555160f339a11dcfed6.svg";
export { ForwardRef as ReactComponent };